import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { AppRouter } from "./router.js";
import { SessionProvider } from "./session/SessionProvider.js";
import "./design/fonts.css";
import "./design/tokens.css";
import "./design/base.css";
import "./design/components.css";
import "./marketing/marketing.css";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <SessionProvider><AppRouter /></SessionProvider>
    </BrowserRouter>
  </StrictMode>,
);
